import { Button, CardActions, Tab, Tabs, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { MicrosoftExcel, Plus } from 'mdi-material-ui'
import { useState } from 'react'
import AddDoc from 'src/views/docs/AddDoc'
import TableDocs from 'src/views/docs/TableDocs'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'

const DocList = () => {
    const [query, setQuery] = useState({});
    const [show, setShow] = useState(false)
    const [reload, setReload] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const params = {
        'column': '',
        'query': ''
    };

    const sheetDownload = async () => {
        try {
            const response = await apiService.get('/docs/download', {
                responseType: 'blob',
                params: {
                    mode: tabIndex+1,
                    column: params.column,
                    query: params.query
                }
            });
            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "문서리스트.xlsx";
            document.body.appendChild(a);
            a.click();
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    return (
        <Page title="Docs">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Typography variant='h5' color='#666CFF'>
                            COA & MSDS 문서관리
                        </Typography>
                    }
                />
                <BoxWrapper>
                    <Tabs 
                        value={tabIndex}
                        onChange={(e, newValue) => setTabIndex(newValue)}
                    >
                        <Tab label="COA" />
                        <Tab label="MSDS" />
                    </Tabs>

                    {tabIndex === 0 && <TableDocs tabs="COA" mode={1} filters={params} submit={reload} />}
                    {tabIndex === 1 && <TableDocs tabs="MSDS" mode={2} filters={params} submit={reload} />}                
                </BoxWrapper>
                <CardActions className='card-action'>
                    <Button variant="contained" startIcon={<Plus />} color="warning" onClick={()=>{setShow(true)}}>등록</Button>
                    <Button variant='contained' startIcon={<MicrosoftExcel />} onClick={sheetDownload}>엑셀 다운로드</Button>
                </CardActions>
                <AddDoc show={show} setShow={setShow} setReload={setReload} />
            </Grid>
        </Page>
    )
}

export default DocList